export default __webpack_public_path__ + "static/media/686.2cabe91a.png";